import React from "react";
import { Link } from "react-router-dom";
import "../styles/saving.scss";
import { Search } from "./components/Search";
import a from "../assets/images/savings/a.png";
import cu from "../assets/images/savings/cu.png";
import jade from "../assets/images/savings/jade.png";
import fe from "../assets/images/savings/fe.png"
import pottery from "../assets/images/savings/pottery.png";
import paint from "../assets/images/savings/paint.png";
import other from "../assets/images/savings/other.png";
;



export class Saving extends React.Component {
    savingClick = (url: string) => {
    }
    render(): JSX.Element { // document.querySelector("#submenu")!.children[id].classList.add("choiced");
        return (
            <section className="savinginfo  headerinfo info bg">
                <div className="saving ">

                    <div onClick={() => document.location.href = '/views/saving/savingType/0'}>
                        <img src={a} alt="" />
                        <Link to={"/views/saving/savingType/0"}>铜器</Link>
                        <img src={cu} alt="" />

                    </div>


                    <div onClick={() => document.location.href = '/views/saving/savingType/1'}>
                        <img src={a} alt="" />
                        <Link to={"/views/saving/savingType/1"}>玉石器</Link>
                        <img src={jade} />

                    </div>
                    <div onClick={() => document.location.href = '/views/saving/savingType/2'}>
                        <img src={a} alt="" />
                        <Link to={"/views/saving/savingType/2"}>陶瓷器</Link>
                        <img src={pottery} />

                    </div>
                    <div onClick={() => document.location.href = '/views/saving/savingType/3'}>
                        <img src={a} alt="" />
                        <Link to={"/views/saving/savingType/3"}>书画</Link>
                        <img src={paint} />
                    </div>
                    <div onClick={() => document.location.href = '/views/saving/savingType/4'} >
                        <img src={a} alt="" />
                        <Link to={"/views/saving/savingType/4"}>金银器</Link>
                        <img src={fe} alt="" />


                    </div>

                    <div onClick={() => document.location.href = '/views/saving/savingType/5'} >
                        <img src={a} alt="" />
                        <Link to={"/views/saving/savingType/5"}>其他</Link>
                        <img src={other} alt="" />

                    </div>

                </div>



            </section>
        )
    }
}